import axios, { AxiosResponse } from 'axios';

import { APIError, UnsupportedStructureError } from '~services/Errors';

import { RealtimeTranscriptResponseDecoder, Rule, RuleResponseDecoder, TranscriptRecord } from './domain';

export const getRealtimeTranscriptRecords = async (contactId: string): Promise<TranscriptRecord[]> => {
  const path = `/api/contact-analytics/realtime/${contactId}`;
  let resp: AxiosResponse;

  try {
    resp = await axios({
      method: 'GET',
      url: path,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (e) {
    if (axios.isAxiosError(e)) {
      // Response should always be defined if axios error
      throw new APIError(e.response!.status, (e.response!.data as { error: string }).error || e.message);
    }

    throw new APIError(-1, e as string);
  }

  const decoded = RealtimeTranscriptResponseDecoder.run(resp.data);

  if (decoded.ok === false) {
    const err = new UnsupportedStructureError(decoded.error.message);

    console.error(decoded.error);
    console.error(err);
    throw err;
  }

  return decoded.result;
};

export const getRules = async (campaignId: number): Promise<Rule[]> => {
  const path = `/api/contact-analytics/rules/${campaignId}`;
  let resp: AxiosResponse;

  try {
    resp = await axios({
      method: 'GET',
      url: path,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (e) {
    if (axios.isAxiosError(e)) {
      // Response should always be defined if axios error
      throw new APIError(e.response!.status, (e.response!.data as { error: string }).error || e.message);
    }

    throw new APIError(-1, e as string);
  }

  const decoded = RuleResponseDecoder.run(resp.data);

  if (decoded.ok === false) {
    const err = new UnsupportedStructureError(decoded.error.message);

    console.error(decoded.error);
    console.error(err);
    throw err;
  }

  return decoded.result;
};
